import { TableColumnUI } from '../../../common/ui/table/TableColumnUI'
import { TableColumnsUI } from '../../../common/ui/table/TableColumnsUI'
import { TableRowsUI } from '../../../common/ui/table/TableRowsUI'
import { TableUI } from '../../../common/ui/table/TableUI'
import { PaymentUI } from './PaymentUI'

export type PaymentsUI = {
  totalPayment: number
  payments: PaymentUI[]
}

export const getPaymentsTable = (paymentsUI: PaymentsUI): TableUI => {
  const columnsUI: TableColumnsUI = {
    columns: [
      {
        id: 'description',
        text: 'users.transactions.description',
      } satisfies TableColumnUI,
      {
        id: 'paid',
        text: 'users.transactions.paid',
        width: 70,
      } satisfies TableColumnUI,
    ],
  }

  const rowsUI: TableRowsUI = {
    rows: paymentsUI.payments.map((payment: PaymentUI) => ({
      id: payment.id,
      row: payment,
    })),
  } satisfies TableRowsUI

  return {
    columnsUI,
    rowsUI,
  } satisfies TableUI
}
